import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Login from '@/pages/Login'

import Product from '@/pages/Product'
import ShowProduct from '@/pages/product/Show'
import NewProduct from '@/pages/product/New'
import Item from '@/pages/Item'
import ShowItem from '@/pages/item/Show'
import NewItem from '@/pages/item/New'

import Search from '@/pages/Search'

import User from '@/pages/User'
import ShowUser from '@/pages/user/Show'
import NewUser from '@/pages/user/New'

import Install from '@/pages/Install'
import PageNotFound from '@/pages/PageNotFound'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/product/new',
      name: 'NewProduct',
      component: NewProduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/product/:id',
      name: 'ShowProduct',
      component: ShowProduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/item',
      name: 'Item',
      component: Item,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/item/new',
      name: 'NewItem',
      component: NewItem,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/item/:id',
      name: 'ShowItem',
      component: ShowItem,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/user/new',
      name: 'NewUser',
      component: NewUser,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:id',
      name: 'ShowUser',
      component: ShowUser,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/install',
      name: 'Install',
      component: Install,
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js